import { render, staticRenderFns } from "./ActiveOrder.vue?vue&type=template&id=0aeceea8&scoped=true"
import script from "./ActiveOrder.vue?vue&type=script&lang=js"
export * from "./ActiveOrder.vue?vue&type=script&lang=js"
import style0 from "./ActiveOrder.vue?vue&type=style&index=0&id=0aeceea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeceea8",
  null
  
)

export default component.exports